import api from './api';

/**
 * Получить статус синхронизации с Dropbox
 */
export const getSyncStatus = async () => {
  const response = await api.get('/api/sync/status');
  return response.data;
};

/**
 * Получить список файлов в Dropbox
 */
export const getSyncFiles = async (params = {}) => {
  const response = await api.get('/api/sync/files', { params });
  return response.data;
};

/**
 * Экспортировать данные из БД в Dropbox
 */
export const exportToDropbox = async () => {
  const response = await api.post('/api/sync/export');
  return response.data;
};

/**
 * Скачать файл из Dropbox
 */
export const downloadFile = async (filename) => {
  const response = await api.get(`/api/sync/files/${filename}`, {
    responseType: 'blob',
  });
  return response.data;
};

/**
 * Удалить файл из Dropbox
 */
export const deleteFile = async (filename) => {
  const response = await api.delete(`/api/sync/files/${filename}`);
  return response.data;
};
